function isValidEmail(email) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}

function isValidPhone(phone) {
    const phoneNumber = phone.trim();
    const regex = /^[\+|\d]{9,13}$/g;
    return regex.test(phoneNumber);
}

$("#game_submit_ourgame").on("click", function (e) {
    e.preventDefault();
    let hasError = false;

    $(".input-block").removeClass("error");
    $(".error-note").addClass("hidden");

    const $gameErrorBlock = $('#game_error').closest('.input-block');
    $gameErrorBlock.removeClass('error');
    $('#game_error').addClass('hidden').text('');

    const fields = [{
        id: "#game-answer",
        name: "Отговор"
    },
    {
        id: "#game-name",
        name: "Име"
    },
    {
        id: "#game-surname",
        name: "Фамилия"
    },
    {
        id: "#game-email",
        name: "Email",
        type: "email"
    },
    {
        id: "#game-phone",
        name: "Телефон",
        type: "phone"
    },
    ];

    fields.forEach(field => {
        const $el = $(field.id);
        const val = $el.val().trim();

        if (val === "" ||
            (field.type === "email" && !isValidEmail(val)) ||
            (field.type === "phone" && !isValidPhone(val))
        ) {
            $el.closest(".input-block").addClass("error");
            const msg = (val === "") ?
                `Полето не може да бъде празно` :
                (field.type === "email") ?
                    "Невалиден e-mail" :
                    "Невалиден телефонен номер";

            $el.siblings(".error-note").removeClass("hidden").text(msg);
            hasError = true;
        }
    });

    if (!$("#game-years-checkbox").is(":checked")) {
        $("#game-years-checkbox").closest(".input-group").addClass("error");
        $("#game-years-checkbox").closest(".input-group").find(".error-note").removeClass("hidden");
        hasError = true;
    }

    if (!$("#game-terms-checkbox").is(":checked")) {
        $("#game-terms-checkbox").closest(".input-group").addClass("error");
        $("#game-terms-checkbox").closest(".input-group").find(".error-note").removeClass("hidden");
        hasError = true;
    }

    if (hasError) return;

    const email = $("#game-email").val().trim();
    const name = $("#game-name").val().trim();
    const surname = $("#game-surname").val().trim();
    const phone = $("#game-phone").val().trim();
    const answer = $("#game-answer").val().trim();
    const questionId = $("#question_id_ourgame").val();
    const years = $("#game-years-checkbox").is(":checked");
    const terms = $("#game-terms-checkbox").is(":checked");

    gameOurGame(email, name, surname, phone, answer, questionId, years, terms);

    function gameOurGame(email, name, surname, phone, answer, questionId, years, terms) {
        $.ajax({
            type: "POST",
            url: '/bg-football/games/save_user_vote_our_game',
            crossDomain: true,
            dataType: "json",
            data: {
                userEmail: email,
                userName: name,
                userSurname: surname,
                userYears: years,
                userTerms: terms,
                userPhone: phone,
                userAnswer: answer,
                questionId: questionId,
                gameDomainName: 'game_ourgame'
            },
            success: function (response) {
                var data = response;
                const $dialog = $('#not_worldcup_our_game');
                const $modalTitle = $dialog.find('.modal-body-title');

                if (data['success'] == 1) {
                    $modalTitle.text('Регистрацията Ви е успешна!');
                } else {
                    $modalTitle.text(data['msg']);
                }

                $dialog.find('form').hide();
                $('.our-game-button[data-id="not_worldcup_our_game"]').hide();

                setTimeout(() => {
                    $dialog[0].close();
                    $dialog.removeClass('g-shown');
                    $('.profile-overlay').hide();
                    $('body').css('overflow', 'auto');
                }, 2000);
            }
        });
    }

});